import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UserService} from './user.service';
import {CurrentDayService} from './current-day.service';
import {employeePropertiesBitmaskServiceProvider} from './upgrade/employee-properties-bitmask.service';
import {loaderServiceProvider} from './upgrade/loader.service';
import {syncServiceProvider} from './upgrade/sync.service';
import {ToWordsPipe} from './to-words.pipe';
import {locationServiceProvider} from './upgrade/location.service';
import {FixedTableHeaderDirective} from './fixed-table-header.directive';
import {holidaysWeekendsCheckServiceProvider} from './upgrade/holidays-weekends-check-service.service';
import {userServiceProvider} from './upgrade/user.service';
import {WindowRef} from './window-ref.service';
import {NyTzMoment} from './ny-tz-moment.service';
import {daysCounterServiceProvider} from './upgrade/days-counter.service';
import {EmployeeFilterComponent} from './employee-filter/employee-filter.component';

@NgModule({
	imports: [FormsModule, CommonModule],
	exports: [
		FormsModule,
		CommonModule,
		ToWordsPipe,
		FixedTableHeaderDirective,
		EmployeeFilterComponent,
	],
	providers: [
		UserService,
		CurrentDayService,
		employeePropertiesBitmaskServiceProvider,
		syncServiceProvider,
		loaderServiceProvider,
		locationServiceProvider,
		holidaysWeekendsCheckServiceProvider,
		userServiceProvider,
		locationServiceProvider,
		daysCounterServiceProvider,
		WindowRef,
		NyTzMoment
	],
	declarations: [
		ToWordsPipe,
		FixedTableHeaderDirective,
		EmployeeFilterComponent,
	],
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts